import React from 'react';
import PropTypes from 'prop-types';
import DifferenceRect from 'components/difference-rect';
import {isActive} from 'utils/interaction-util';
import {getBarY, getHeight} from 'utils/layout-util';
import styles from './index.css';

export default class DifferenceBarSeries extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    barHeight: PropTypes.number,
    data: PropTypes.array,
    interactive: PropTypes.bool,
    scale: PropTypes.func,
    verticalSpacing: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: -1,
    barHeight: 0,
    data: [],
    interactive: true,
    scale: () => {},
    verticalSpacing: 0,
  };

  getBarStyle(color) {
    return {
      fill: color,
    };
  }

  getBarWidth(scale, expected, value) {
    return value > expected
      ? Math.ceil(scale(value - expected))
      : Math.floor(scale(expected - value));
  }

  getBarX(scale, expected, value) {
    return value > expected
      ? Math.ceil(scale(expected))
      : Math.floor(scale(value));
  }

  render() {
    const {activeIndex, barHeight, data, interactive, scale, verticalSpacing} =
      this.props;
    return (
      <g className={styles.DifferenceBarSeries}>
        {data.map((datum, index) => {
          const {color, expected, value} = datum;
          const active = isActive(activeIndex, index, interactive);
          const height = getHeight(barHeight);
          const style = this.getBarStyle(color);
          const width = this.getBarWidth(scale, expected, value);
          const x = this.getBarX(scale, expected, value);
          const y = getBarY(barHeight, verticalSpacing, index);
          return active ? (
            <DifferenceRect
              active={active}
              height={height}
              key={index}
              style={style}
              width={width}
              x={x}
              y={y}
            />
          ) : null;
        })}
      </g>
    );
  }
}
